var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.47289C3 5.58431 3.55086 4.79542 4.36754 4.51442L11.3675 2.10594C11.7781 1.96469 12.2219 1.96469 12.6325 2.10594L19.6325 4.51442C20.4491 4.79542 21 5.58431 21 6.47289V13.9608C21 15.7588 20.0935 17.4271 18.6073 18.3646L13.5643 21.5457C12.604 22.1514 11.396 22.1514 10.4356 21.5457L5.39275 18.3646C3.90648 17.4271 3 15.7588 3 13.9608V6.47289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt1);
export default __webpack_public_path__ + "static/media/shield-alt-1.6eb010f11228b705cc80772cc4d55e1b.svg";
export { ForwardRef as ReactComponent };